import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { contactInfo } from '../../mock';

const information = [
  { icon: MapPin, title: 'Adres', lines: [contactInfo.address] },
  { icon: Phone, title: 'Telefon', lines: [contactInfo.phone] },
  { icon: Mail, title: 'E-posta', lines: contactInfo.emails },
  { icon: Clock, title: 'Calisma Saatleri', lines: ['Pzt - Cum: 09:00 - 18:00', 'Cmt: 09:00 - 14:00'] },
];

const InfoCard = ({ icon: Icon, title, lines }) => (
  <div data-testid={`contact-info-${title.toLowerCase().replace(/\s+/g, '-')}`} className="group p-6 rounded-2xl bg-card border border-border hover:border-primary/50 transition-all duration-500 hover:-translate-y-1">
    <div className="w-11 h-11 rounded-xl border border-primary/30 bg-primary/10 flex items-center justify-center mb-5 group-hover:bg-primary/15 group-hover:border-primary/60 transition-colors duration-500"><Icon size={18} strokeWidth={1.6} className="text-accent" /></div>
    <h3 className="text-[11px] tracking-[0.28em] text-accent font-medium mb-3">{title.toUpperCase()}</h3>
    <div className="space-y-1">{lines.map((line) => <p key={line} className="text-[13.5px] text-white/70 leading-relaxed break-words">{line}</p>)}</div>
  </div>
);

export const ContactInfoCards = () => (
  <section className="px-6 lg:px-10 pb-12">
    <div className="max-w-[1300px] mx-auto grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
      {information.map((entry) => <InfoCard key={entry.title} {...entry} />)}
    </div>
  </section>
);